var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgI(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 483.78 483.78"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1016"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 70"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.89,
    cy: 241.89,
    r: 241.89,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.89 475.17a233.29 233.29 0 01-165-398.24 233.28 233.28 0 11329.95 329.91 231.71 231.71 0 01-164.95 68.33zm0-446.56c-117.6 0-213.28 95.67-213.28 213.28s95.68 213.28 213.28 213.28 213.28-95.68 213.28-213.28S359.49 28.61 241.89 28.61z",
    fill: "#838383"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.41 102.63c0-23.7 19.84-43.54 43.54-43.54s43.54 19.84 43.54 43.54-19.83 43.54-43.49 43.54-43.59-19.83-43.59-43.54zm7.26 64.83h72.57v241.89h-72.57z",
    fill: "#838383"
  }))))));
}

export default SvgI;